import type { FC, SVGProps } from 'react';
import IconArrowLeft from './icons/icon-arrow-left.svg?react';
import IconArrowRight from './icons/icon-arrow-right.svg?react';
import IconBell from './icons/icon-bell.svg?react';
import IconBlockEmail from './icons/icon-block-email.svg?react';
import IconBook from './icons/icon-book.svg?react';
import IconBrowserBlock from './icons/icon-browser-block.svg?react';
import IconCalendar from './icons/icon-calendar.svg?react';
import IconCall from './icons/icon-call.svg?react';
import IconChat from './icons/icon-chat.svg?react';
import IconCheckmark from './icons/icon-checkmark.svg?react';
import IconCheckmarkSmall from './icons/icon-checkmark-small.svg?react';
import IconCheckmarkXSmall from './icons/icon-checkmark-xsmall.svg?react';
import IconChevronDown from './icons/icon-chevron-down.svg?react';
import IconClose from './icons/icon-close.svg?react';
import IconDarkWeb from './icons/icon-dark-web.svg?react';
import IconDelete from './icons/icon-delete.svg?react';
import IconExclamationCircleEmpty from './icons/icon-exclamation-circle-empty.svg?react';
import IconExclamationSmall from './icons/icon-exclamation-small.svg?react';
import IconExplicitContent from './icons/icon-explicit-content.svg?react';
import IconEyeClosed from './icons/icon-eye-closed.svg?react';
import IconEyeOpened from './icons/icon-eye-opened.svg?react';
import IconFacebook from './icons/icon-facebook.svg?react';
import IconFraudAlert from './icons/icon-fraud-alert.svg?react';
import IconGooglePlay from './icons/icon-google-play.svg?react';
import IconHome from './icons/icon-home.svg?react';
import IconIdentityProtection from './icons/icon-identity-protection.svg?react';
import IconInstagram from './icons/icon-instagram.svg?react';
import IconInsurance from './icons/icon-insurance.svg?react';
import IconIos from './icons/icon-ios.svg?react';
import IconKey from './icons/icon-key.svg?react';
import IconLinkedin from './icons/icon-linkedin.svg?react';
import IconLoader from './icons/icon-loader.svg?react';
import IconLoan from './icons/icon-loan.svg?react';
import IconLock from './icons/icon-lock.svg?react';
import IconLoyaltyCard from './icons/icon-loyalty-card.svg?react';
import IconMail from './icons/icon-mail.svg?react';
import IconMegaphone from './icons/icon-megaphone.svg?react';
import IconMessage from './icons/icon-message.svg?react';
import IconPlay from './icons/icon-play.svg?react';
import IconSettings from './icons/icon-settings.svg?react';
import IconShieldCheck from './icons/icon-shield-check.svg?react';
import IconSupport from './icons/icon-support.svg?react';
import IconSupportQuestion from './icons/icon-support-question.svg?react';
import IconTarget from './icons/icon-target.svg?react';
import IconUnlock from './icons/icon-unlock.svg?react';
import IconUserProfile from './icons/icon-user-profile.svg?react';
import IconUserProtected from './icons/icon-user-protected.svg?react';
import IconUserSearch from './icons/icon-user-search.svg?react';
import IconWhatsup from './icons/icon-whatsup.svg?react';
import IconX from './icons/icon-x.svg?react';
import IconYoutube from './icons/icon-youtube.svg?react';

export type SharedIconName =
  | 'arrow-left'
  | 'arrow-right'
  | 'bell'
  | 'block-email'
  | 'book'
  | 'browser-block'
  | 'calendar'
  | 'call'
  | 'chat'
  | 'checkmark'
  | 'checkmark-small'
  | 'checkmark-xsmall'
  | 'chevron-down'
  | 'close'
  | 'dark-web'
  | 'delete'
  | 'exclamation-circle-empty'
  | 'exclamation-small'
  | 'explicit-content'
  | 'eye-closed'
  | 'eye-opened'
  | 'facebook'
  | 'fraud-alert'
  | 'google-play'
  | 'home'
  | 'identity-protection'
  | 'instagram'
  | 'insurance'
  | 'ios'
  | 'key'
  | 'linkedin'
  | 'loader'
  | 'loan'
  | 'lock'
  | 'loyalty-card'
  | 'mail'
  | 'megaphone'
  | 'message'
  | 'play'
  | 'settings'
  | 'shield-check'
  | 'support-question'
  | 'support'
  | 'target'
  | 'unlock'
  | 'user-profile'
  | 'user-protected'
  | 'user-search'
  | 'whatsup'
  | 'x'
  | 'youtube';

interface SharedIconProps extends SVGProps<SVGSVGElement> {
  name: SharedIconName;
  size?: 12 | 16 | 18 | 24 | 32 | 48 | 64;
  color?: string;
}

const iconMap: Record<SharedIconName, FC<SVGProps<SVGSVGElement>>> = {
  'arrow-left': IconArrowLeft,
  'arrow-right': IconArrowRight,
  bell: IconBell,
  'block-email': IconBlockEmail,
  book: IconBook,
  'browser-block': IconBrowserBlock,
  calendar: IconCalendar,
  call: IconCall,
  chat: IconChat,
  checkmark: IconCheckmark,
  'checkmark-small': IconCheckmarkSmall,
  'checkmark-xsmall': IconCheckmarkXSmall,
  'chevron-down': IconChevronDown,
  close: IconClose,
  'dark-web': IconDarkWeb,
  delete: IconDelete,
  'exclamation-circle-empty': IconExclamationCircleEmpty,
  'exclamation-small': IconExclamationSmall,
  'explicit-content': IconExplicitContent,
  'eye-closed': IconEyeClosed,
  'eye-opened': IconEyeOpened,
  facebook: IconFacebook,
  'fraud-alert': IconFraudAlert,
  'google-play': IconGooglePlay,
  home: IconHome,
  'identity-protection': IconIdentityProtection,
  instagram: IconInstagram,
  insurance: IconInsurance,
  ios: IconIos,
  key: IconKey,
  linkedin: IconLinkedin,
  loader: IconLoader,
  loan: IconLoan,
  lock: IconLock,
  'loyalty-card': IconLoyaltyCard,
  mail: IconMail,
  megaphone: IconMegaphone,
  message: IconMessage,
  play: IconPlay,
  settings: IconSettings,
  'shield-check': IconShieldCheck,
  'support-question': IconSupportQuestion,
  support: IconSupport,
  target: IconTarget,
  unlock: IconUnlock,
  'user-profile': IconUserProfile,
  'user-protected': IconUserProtected,
  'user-search': IconUserSearch,
  whatsup: IconWhatsup,
  x: IconX,
  youtube: IconYoutube,
};

export const SharedIcon: FC<SharedIconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  style,
  ...props
}) => {
  const IconComponent = iconMap[name];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      {...props}
      width={size}
      height={size}
      style={{ ...style, minWidth: size, fill: color }}
      aria-hidden="true"
    />
  );
};
